// extracted by mini-css-extract-plugin
export default {"content":"SocietyArticles_content__x4VjK","realContent":"SocietyArticles_realContent__SCfwI"};